<template>
  <div>
    <!-- 退出弹框 -->
    <modalDefault :showModal="showModal" @close="close()" @confirm="confirm()" modalText="绑定邀请码"
      btnStyle="bottom: 30px;">
      <template #dialogContent>
        <div class="update-take-pwd-form">
          <div class="form-back">
            <div class="label">邀请码</div>
            <div class="input-box">
              <input class="input" type="text" placeholder="请输入您的邀请码" v-model="code"
                placeholder-style="font-size:24rpx;color: #9fafe7" />
            </div>
            <p class="tips" style="font-size: 14px;">*邀请码仅可绑定一次，请谨慎操作</p>
          </div>
        </div>
      </template>
    </modalDefault>
  </div>
</template>
<script>
import modalDefault from "@/components/common/modalDefault.vue";
export default {
  name: "modalBindCode",
  components: {
    modalDefault,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      code: "",
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    confirm() {
      this.$emit("confirm", this.code);
    },
  },
};
</script>
<style lang="scss" scoped>
.update-take-pwd-form {
  width: 86%;
  height: 55.62 * 4.2px;
  margin-top: 4.76 * 4.2px;

  @media only screen and (max-width: 430px) {
    height: 55.62vw;
    margin-top: 4.76vw;
  }
}

.form-back {
  width: 100%;
  background-color: #302077;
  height: 32.19 * 4.2px;
  border-radius: 1.19 * 4.2px;
  padding: 3.76 * 4.2px;

  @media only screen and (max-width: 430px) {
    height: 32.19vw;
    border-radius: 1.19vw;
    padding: 3.76vw;
  }
}

.update-take-pwd-form .form-back .label {
  width: 100%;
  height: 7.47 * 4.2px;
  line-height: 7.47 * 4.2px;
  color: #a6bbff;
  text-align: left;
  margin-bottom: 5px;
}

.input-box {
  width: 68.4 * 4.2px;
  height: 7.73 * 4.2px;
  // background: url("../../assets/images/realNameBtn.png") no-repeat 0 0;
  // background-size: 58.4 * 4.2px 7.73 * 4.2px;
  background: #031543;
  border-radius: 4px 4px 4px 4px;

  @media only screen and (max-width: 430px) {
    width: 68.4vw;
    height: 7.73vw;
  }
}

.input-box .input {
  width: 100%;
  height: 32.466px;
  line-height: 32.466px;
  text-align: left;
  background: transparent;
  font-size: 3.33 * 4.2px;
  padding-left: 8px;
  box-sizing: border-box;
}

.input-box .input::-webkit-input-placeholder {
  color: #a6bbff;
  font-size: 3.33 * 4.2px;
}

.input-box .input::-moz-placeholder {
  color: #a6bbff;
  font-size: 3.33 * 4.2px;
}

.input-box .input::-ms-input-placeholder {
  color: #a6bbff;
  font-size: 3.33 * 4.2px;
}

.input-box .input::placeholder {
  color: #a6bbff;
  font-size: 3.33 * 4.2px;
}
</style>